module.exports = __webpack_public_path__ + "img/m_cfsq.5ee24089.png";